<template>
  <div class="ContactBar">
    <div class="ContactBar__info">
      <img
      class="ContactBar__image"
      :src="contact.avatarUrl || '/images/default-user-avatar.jpg'"/>
      <div class="ContactBar__name">{{ contact.contactName }}</div>
    </div>
    <el-button
    class="ContactBar__button"
    :type="buttonType"
    size="small"
    :disabled="isDisabled"
    :loading="isLoading"
    @click="sendMessage"
    round>
      {{ buttonState }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'ContactBar',

  props: {
    contact: {
      type: Object,
      required: true,
      validator (contact) {
        return contact.contactName && contact.userId
      }
    },
    sent: {
      type: Boolean,
      required: false
    },
    failed: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      busy: false
    }
  },

  computed: {
    buttonType () {
      if (this.failed) return 'danger'
      return this.sent ? 'success' : 'primary'
    },
    buttonState () {
      if (this.failed) return 'Failed'
      if (this.busy && !this.sent) return 'Sending...'
      else return this.sent ? 'Sent' : 'Send'
    },
    isDisabled () {
      return this.sent || this.failed || this.busy
    },
    isLoading () {
      return this.busy && !this.sent && !this.failed
    }
  },

  methods: {
    sendMessage () {
      if (this.busy || this.sent) return
      this.busy = true
      this.$emit('sendMessage', this.contact.userId)
    }
  }
}
</script>

<style lang="scss">
@import 'ContactBar';
</style>
